import { useTranslations } from '@vocab/react';
import { Text, TooltipRenderer, Box } from 'braid-design-system';

import { IconSeekPassSupertick } from 'src/components/common/Certsy/Icons/IconSeekPassSupertick/IconSeekPassSupertick';

import translations from './.vocab';

export const CertsyIdentityVerified = ({
  idSuffix,
  certsyVerifiedFullName,
}: {
  idSuffix: string;
  certsyVerifiedFullName: string;
}) => {
  const { t } = useTranslations(translations);

  return (
    <TooltipRenderer
      id={`certsy-identity-verified-tooltip-${idSuffix}`}
      tooltip={
        <Text>
          {t(
            'This person has verified their identity as certsyVerifiedFullName.',
            {
              certsyVerifiedFullName,
            },
          )}
        </Text>
      }
    >
      {({ triggerProps }) => (
        <Box {...triggerProps}>
          <IconSeekPassSupertick />
        </Box>
      )}
    </TooltipRenderer>
  );
};
